const DEFAULT_ATTR = "data-analytics-region";
const DEFAULT_MAX_DEPTH = 2;

interface GetAnalyticsRegionOptions {
  attr?: string;
  maxDepth?: number;
}

/**
 * Traverses up the DOM from the given element, collecting up to `maxDepth`
 * ancestor `attr` values.
 *
 * Result is formatted outermost-first: `"hero > hero_cards"`, or `null`
 * if no region ancestor is found.
 */
export function getAnalyticsRegion(
  target: EventTarget | null,
  {
    attr = DEFAULT_ATTR,
    maxDepth = DEFAULT_MAX_DEPTH,
  }: GetAnalyticsRegionOptions = {},
): string | null {
  if (!(target instanceof HTMLElement)) return null;

  const regions: string[] = [];
  let el: HTMLElement | null = target.parentElement;

  while (el && regions.length < maxDepth) {
    const region = el.getAttribute(attr);
    if (region !== null) {
      regions.push(region);
    }
    el = el.parentElement;
  }

  return regions.length ? regions.reverse().join(" > ") : null;
}
